import * as React from 'react';
import wavesStoryHeader from '../images/waves/waves-reverse.png';
import styled from 'styled-components';

const StoryHeader = styled.div`
	padding: 2em 4% 4em;
	background-color: white;
	background-image: ${(props) => `url('${props.wavesImage}')`};
	background-repeat: no-repeat;
	background-size: 100% 200px;
	background-position: center 80%;
	box-shadow: 0 0 10px #888888;
	border-radius: 10px;
	margin-bottom: 22px;
	width: 100%;

	@media(${(props) => props.theme.mediumUp}) {
		margin-bottom: 55px;
	}

	& h2 {
		margin-bottom: 44px;
		color: ${(props) => props.theme.lightBlue};

		& a {
			color: ${(props) => props.theme.lightBlue};
		}
	}

	& img {
		display: block;
		margin: 0 auto;
		border-radius: 10px;
	}
`; // StoryHeader

const NewsStoryHeader = ({ children }) => (
	<StoryHeader wavesImage={wavesStoryHeader}>
		{children}
	</StoryHeader>
);

export default NewsStoryHeader;
